import { styled } from '@zoopla-eng/zds-components/themes';

const TITLEBAR_HEIGHT = '3.5rem';

const ReassuranceText = styled('p', {
    fontGroup: 'fork',
    fontWeight: '$400',
    textAlign: 'left'
});

const TermsText = styled('p', {
    fontGroup: 'fork',
    textAlign: 'center'
});

const SocialSignInText = styled('p', {
    fontGroup: 'fork',
    color: '$neutral5'
});

const SocialSignInTextWrapper = styled('div', {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    '&::before,&::after': {
        content: '',
        borderBottom: '1px solid $graphicDividerDefault',
        marginBottom: '10px'
    }
});

const SignInErrorMessage = styled('p', {
    fontGroup: 'spoon',
    color: '$functionalError'
});

const SocialTitleWrapper = styled('div', {
    position: 'relative',

    '&::before': {
        content: '',
        display: 'block',
        position: 'absolute',
        left: 0,
        backgroundColor: '$brandPrimary',
        width: '10px',
        top: `-${TITLEBAR_HEIGHT}`,
        height: `calc(100% + ${TITLEBAR_HEIGHT})`,
        zIndex: 1000
    },

    h1: {
        display: 'block',
        // in order for the focus to be visible we use margin instead of padding
        marginLeft: '$M100',
        fontGroup: 'mug',
        '&:focus': {
            outline: 'none'
        },
        '&:focus-visible': {
            outline: 'none',
            boxShadow: '$focusRing'
        }
    },
    '@M100': {
        h1: {
            pr: '$L100'
        }
    }
});

const StyledGeneralError = styled('span', {
    fontGroup: 'fork',
    color: '$functionalError'
});

export {
    ReassuranceText,
    TermsText,
    SocialSignInTextWrapper,
    SocialSignInText,
    SignInErrorMessage,
    SocialTitleWrapper,
    StyledGeneralError
};
